import { render } from "./PsNotificationBox.vue?vue&type=template&id=be94f7ca"
import script from "./PsNotificationBox.vue?vue&type=script&lang=js"
export * from "./PsNotificationBox.vue?vue&type=script&lang=js"

import "./PsNotificationBox.vue?vue&type=style&index=0&id=be94f7ca&lang=css"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__